import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1539a876"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comments" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_comments_filters = _resolveComponent("comments-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_title, { title: "Комментарии КЦ" }),
    _createVNode(_component_comments_filters, {
      class: "mt-6",
      loading: _ctx.state.is_loading,
      onSearch: _ctx.applyFilters,
      onReset: _ctx.resetFilters
    }, null, 8, ["loading", "onSearch", "onReset"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка комментариев произошла ошибка",
            "error-message": _ctx.error_state.message,
            "error-url": _ctx.error_state.url,
            "error-status": _ctx.error_state.status,
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadComments(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.CommentsColumns,
                rows: _ctx.state.list,
                "with-limit": "",
                "pagination-limit": _ctx.filters_state.limit,
                "pagination-total-items": _ctx.state.pagination.total_items,
                "pagination-current-page": _ctx.state.pagination.current_page,
                "pagination-total-pages": _ctx.state.pagination.total_pages,
                onChangePage: _ctx.loadComments,
                onChangeLimit: _ctx.onLimitChange
              }, {
                td: _withCtx(({ column, row }) => [
                  (column.key === 'number')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (row.type === 1)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              class: "text-blue-500",
                              to: `/order/${row.objectId}`,
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row.number), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_3, "-")),
                        _createTextVNode(" / "),
                        (row.type === 2)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 2,
                              class: "text-blue-500",
                              to: `/invoice/${row.objectId}`,
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row.number), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                      ], 64))
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}